
import verifyLabel from '../../../../methods/verifyLabel'
import Store from 'store'

const generateInput = function(type,name,displayName,required,validateNow,validator,options,defaultValue,maxlength){

    const input = {
        name,
        displayName: displayName ? verifyLabel(displayName,Store.state.main.labels) : name.replace(/[.]/gm,'_'),
        type,
        required,
        value: defaultValue ? defaultValue :'',
        validator,
        validates: undefined,
        validateNow: validateNow,
        maxlength: maxlength || 750,
        maxlengthvalidate: maxlength
    }

    if (type === 'select') {
        input.options = options
        input.value = options.length ? options.find(option => option.selected).value : 'error'
    }
    return input
}

  export default generateInput